{
  "name": "angular-client-base-net",
  "version": "0.1.1+17",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-with-browser": "ng serve -o --port 7233",
    "startdebug": "ng serve",
    "startlocal": "ng serve -c testlocal",
    "buildcheck": "ng build -c buildCheck",
    "build": "ng build",
    "buildprod": "ng build -c production",
    "buildtest": "ng build -c test",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/localize": "^22.0.6",
    "@angular/platform-browser": "^22.0.6",
    "@angular/platform-browser-dynamic": "^22.0.6",
    "@angular/router": "^22.0.6",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@syncfusion/ej2-angular-base": "34.1.29",
    "@syncfusion/ej2-angular-buttons": "34.1.29",
    "@syncfusion/ej2-angular-calendars": "34.1.29",
    "@syncfusion/ej2-angular-charts": "34.1.29",
    "@syncfusion/ej2-angular-dropdowns": "34.1.29",
    "@syncfusion/ej2-angular-grids": "34.1.29",
    "@syncfusion/ej2-angular-inputs": "34.1.29",
    "@syncfusion/ej2-angular-navigations": "34.1.29",
    "@syncfusion/ej2-angular-notifications": "34.1.29",
    "@syncfusion/ej2-angular-popups": "34.1.29",
    "@syncfusion/ej2-angular-splitbuttons": "34.1.29",
    "@syncfusion/ej2-base": "34.1.29",
    "@syncfusion/ej2-locale": "34.1.29",
    "bootstrap": "^5.3.8",
    "cldr-data": "^36.0.5",
    "core-js": "^3.49.0",
    "luxon": "^3.7.2",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.0.6",
    "@angular/cli": "^22.0.6",
    "@angular/compiler-cli": "^22.0.6",
    "@angular/language-service": "^22.0.6",
    "@types/luxon": "^3.7.2",
    "@types/node": "^24.13.3",
    "@typescript-eslint/eslint-plugin": "^8.63.0",
    "@typescript-eslint/parser": "^8.63.0",
    "eslint": "^10.6.0",
    "jsdom": "^29.1.1",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "vitest": "^4.1.10"
  }
}
